import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "app" }

import * as echarts from "echarts";
import { provide } from "vue";
import { ref } from "vue";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import zhCN from "ant-design-vue/es/locale/zh_CN";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale("zh-cn");

// echarts
provide("echarts", echarts);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(zhCN),
    theme: {
      token: {
        colorPrimary: '#42b983',
      },
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})